module.exports = __webpack_public_path__ + "static/media/IMG_9341.8b486854.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/IMG_9341.jpg
// module id = 438
// module chunks = 0